import { routeAccessApi } from "../../api";

const RouteAccessService = {
  /**
   * 🔹 Verifica si el usuario autenticado tiene acceso a una ruta
   * @param route ruta del frontend (ej: "/sales/register")
   */
  checkAccess: async (route: string) => {
    const response = await routeAccessApi.fetchCustom(`/check?route=${encodeURIComponent(route)}`);
    return response.data;
  },
};

export default RouteAccessService;
